import { useQuery, gql } from "utils/urql";
import { TopStackQuery } from "types/api";
import SmallPromoItem from "./SmallPromoItem";
import styles from "./TopStack.module.scss";
import NativeAd from "components/ads/Native";

const query = gql`
  query TopStack {
    ${SmallPromoItem.fragment}
    homepageModule(slug: "top-stack", version: "b1") {
      __typename
      ... on HomepagePromoItemList {
        items {
          ...homepageSmallPromoItem
        }
      }
    }
  }
`;

const StoryStrip = () => {
  const [{ data }] = useQuery<TopStackQuery>({ query });

  if (!data || data.homepageModule?.__typename !== "HomepagePromoItemList") {
    return null;
  }

  const articles = data.homepageModule.items;

  return (
    <ul className={styles.root}>
      {articles.map((article, i) => (
        <li className={styles.li} key={article.id}>
          <SmallPromoItem
            {...article}
            lazyImage={false}
            analyticsSection="top stack"
            riverIndex={i + 1}
          />
        </li>
      ))}
      <li className={styles.native}>
        <NativeAd
          targetingPos="native-lead-hp"
          targetingNative="standard,gift"
          className="s-native s-native--standard s-native--small s-native--short-title s-native--disable-border s-native--hp-top"
        />
      </li>
    </ul>
  );
};

export default StoryStrip;
